// /blocks/molecules/share/index.js
(function() {
  const WIDTH = 640;
  const HEIGHT = 680;
  const bound = new WeakSet(); // évite les double-listeners

  function centerPopup(url, title = 'Share') {
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop  = window.screenTop  ?? window.screenY ?? 0;
    const w = window.innerWidth || document.documentElement.clientWidth || screen.width;
    const h = window.innerHeight || document.documentElement.clientHeight || screen.height;
    const left = ((w - WIDTH) / 2) + dualScreenLeft;
    const top  = ((h - HEIGHT) / 2) + dualScreenTop;
    const features = `scrollbars=yes,width=${WIDTH},height=${HEIGHT},top=${top},left=${left}`;
    const win = window.open(url, title, features);
    if (window.focus && win) win.focus();
  }

  function addUtms(baseUrl, source) {
    try {
      const u = new URL(baseUrl, window.location.href);
      if (!u.searchParams.has('utm_source')) {
        u.searchParams.set('utm_source', source);
        u.searchParams.set('utm_medium', 'social');
        u.searchParams.set('utm_campaign', 'share');
      }
      return u.toString();
    } catch {
      return baseUrl;
    }
  }

  function onClick(e) {
    const a = e.currentTarget;
    const network = a.getAttribute('data-network');
    if (!network) return;
    e.preventDefault();

    const href = addUtms(a.getAttribute('href'), network);
    centerPopup(href, `Share ${network}`);
  }

  function bindShareLink(a) {
    if (!a || bound.has(a)) return;
    a.addEventListener('click', onClick);
    bound.add(a);
  }

  function initShare(root = document) {
    root.querySelectorAll('.dg-share .dg-share__btn').forEach(bindShareLink);
  }

  // 1) Init après CHARGEMENT COMPLET (images, fonts, etc.)
  window.addEventListener('load', () => initShare());

  // 2) Support des navigations instantanées (bfcache / swup / turbo)
  window.addEventListener('pageshow', (ev) => {
    // relance si page restaurée depuis cache
    if (ev.persisted) initShare();
  });

  // 3) Si du contenu est injecté dynamiquement après onload (AJAX/Elementor)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.('.dg-share')) initShare(node);
        // au cas où les boutons sont plus profonds
        if (node.querySelector) initShare(node);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 4) Fallback si le script est injecté après load
  if (document.readyState === 'complete') {
    // microtask pour laisser finir d’éventuels autres init
    setTimeout(() => initShare(), 0);
  }
})();
